<template>
  <div>
    <vm-table
        ref="vmTable"
        height="65vh"
        :filter.sync="filter"
        module="basic"
        url="eMDateMaintenances"
        @select="selectTest">
      <el-button
          slot="toolbar"
          type="primary"
          size="mini"
          @click="$refs.editData.open(0)">
        新建
      </el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键词">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" prop="maintenanceDate" label="维护日期"/>
      <el-table-column align="center" prop="maintenanceType" label="维护类型">
        <template slot-scope="scope">
          <span>{{constant.maintenanceType[scope.row.maintenanceType]}}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column align="center" prop="no" label="设备编号"/>-->
      <!--      <el-table-column align="center" prop="name" label="设备名称"/>-->
      <el-table-column align="center" prop="note" label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editData.open(scope.row.pkid)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <data-edit ref="editData" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import DataEdit from "@/views/em/EMRepairOrder/DataEdit";
  import constant from "@/util/constant";
  export default {
    name: "DataList",
    components: {DataEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","/eMDateMaintenances", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
